import styled from "styled-components";

export const StyledQuestionPrompt = styled.label`
  a {
    text-decoration: underline;
  }
`;

export const StyledDescription = styled.span`
  display: block;
  font-weight: 500;
  font-size: 15px;
  margin-top: 17px;
  margin-bottom: 12px;
  color: ${({ theme }) => theme.deprecatedColors.accent.four};
  a {
    text-decoration: underline;
  }
`;

export const RequiredMarker = styled.span`
  color: ${({ theme }) => theme.deprecatedColors.error};
`;
